import axios from '@/plugins/axios'
import util from '@/services/util'

const apiEndPoint = 'ticket-visibility'

export default {
    namespaced: true,

    state: {
        ticketsVisibility: []
    },

    getters: {
        getTicketVisibilityByType: state => type => {
            const tvs = state.ticketsVisibility.find(ticket => ticket.type === type)
            if (tvs) {
                return JSON.parse(JSON.stringify(tvs))
            }
            return null
        }
    },

    mutations: {
        setTicketsVisibility (state, tvs) {
            state.ticketsVisibility = tvs
        }
    },

    actions: {
        async fetchTicketsVisibility (context, query) {
            const response = await axios.get(util.buildUrlWithQuery(apiEndPoint, query))
            context.commit('setTicketsVisibility', response)
        },

        async deleteTicketVisiblity (context, id) {
            await axios.delete(`${apiEndPoint}/${id}`)
        },

        async updateTicketVisibility (context, payload) {
            const request = {
                type: payload.type,
                fromDate: payload?.date?.[0] ?? null,
                toDate: payload?.date?.[1] ?? null,
                visibilityType: payload.visibilityType
            }
            await axios.patch(`${apiEndPoint}/${payload.type}`, request)
        },

        async createTicketVisibility (context, payload) {
            const request = {
                type: payload.type,
                fromDate: payload?.date?.[0] ?? null,
                toDate: payload?.date?.[1] ?? null,
                visibilityType: payload.visibilityType
            }
            await axios.post(`${apiEndPoint}`, request)
        }
    }
}
